import AuthFlow from '@common/vanilla_ui/auth/authFlow';
import { showContactNumberOnReviewPage } from '@common/utils/ads';
import tracking from '@success_stories_landing/pages/landing/tracking';

const PRODUCT_NAME = 'Alumni Directory';

window.addEventListener('load', async () => {
  window.TrackingHelper?.setContext('event_data', {
    product: PRODUCT_NAME,
  });

  if (document.getElementById('auth-modal')) {
    new AuthFlow('auth-modal');
  }

  showContactNumberOnReviewPage();
  tracking.initialize();
});
